import { CommonData, KLineSourceData, KLineOptions } from "./draw_gold_chart"
import { DrawSVG } from "./draw_svg"
import { drawWaterMark } from "./watermark"

export function drawSpreadKLine(svg: DrawSVG, data: any, gold_spread_common_data: any, options: KLineOptions, container: HTMLElement) {
  const { SHAU_Data, XAU_Data, Gold_Spread_Data } = data
  let { gold_common_data, spread_common_data } = gold_spread_common_data

  const { gold_high_price, gold_low_price, gold_middle_price1, gold_middle_price2, gold_middle_price3, x_interval, info_height } = gold_common_data
  let { high_price, low_price, max_zde, middle_price1, middle_price2, middle_price3, min_price, y_interval } = spread_common_data

  let { decimal } = SHAU_Data

  let { width, height, fontsize } = options

  let rect_width = x_interval - 2 > 0 ? Math.round(x_interval) : 1
  let gold_price_gap = gold_high_price - gold_low_price
  let ih = options.height - info_height * 2

  let spread_gap = Number(high_price.toFixed(0)) - Number((low_price).toFixed(0))

  // 上海金
  let price_info_y = Number((info_height - fontsize / 2).toFixed(2))
  let stockIcon = svg.HLine(5, info_height / 2, 8)
  stockIcon.attr({ stroke: "#0065d6", "stroke-width": 2 })
  let stockName = svg.Text(15, price_info_y)
  stockName.ele.textContent = SHAU_Data.name
  stockName.attr({ class: "gold-name" })

  let stockPrice = svg.Text((window.innerWidth < 360 ? 15 : 20) + stockName.ele.getComputedTextLength(), price_info_y)
  let sh_zde = SHAU_Data.klines[SHAU_Data.klines.length - 1].zde
  let sh_date = SHAU_Data.klines[SHAU_Data.klines.length - 1].date
  let today = new Date().toISOString().substring(0,10)
  stockPrice.ele.textContent = SHAU_Data.klines[SHAU_Data.klines.length - 1].close
  if(sh_date != today){
    stockPrice.attr({ class: "gold-price-flat" })
  }else{
    stockPrice.attr({ class: sh_zde > 0 ? "gold-price-up" : sh_zde < 0 ? "gold-price-down" : "gold-price-flat" })
  }

  // 伦敦金
  let x_stockIcon = svg.HLine((window.innerWidth < 360 ? 60 : 70) + stockPrice.ele.getComputedTextLength(), info_height / 2, 8)
  x_stockIcon.attr({ stroke: "#e19735", "stroke-width": 2 })
  let x_stockName = svg.Text((window.innerWidth < 360 ? 70 : 80) + stockPrice.ele.getComputedTextLength(), price_info_y)
  x_stockName.ele.textContent = XAU_Data.name
  x_stockName.attr({ class: "gold-name" })

  let x_stockPrice = svg.Text((window.innerWidth < 360 ? 70 : 85) + stockPrice.ele.getComputedTextLength() + x_stockName.ele.getComputedTextLength(), price_info_y)
  let x_zde = XAU_Data.klines[XAU_Data.klines.length - 1].zde
  x_stockPrice.ele.textContent = XAU_Data.klines[XAU_Data.klines.length - 1].close
  x_stockPrice.attr({ class: x_zde > 0 ? "gold-price-up" : x_zde < 0 ? "gold-price-down" : "gold-price-flat" })

  // 价差
  let spread_Icon = svg.HLine((window.innerWidth < 360 ? 75 : 95) + stockPrice.ele.getComputedTextLength() + x_stockName.ele.getComputedTextLength() + x_stockPrice.ele.getComputedTextLength(), info_height / 2, 8)
  spread_Icon.attr({ stroke: "#fc651c", "stroke-width": 2 })
  let spread_name = svg.Text((window.innerWidth < 360 ? 85 : 105) + stockPrice.ele.getComputedTextLength() + x_stockName.ele.getComputedTextLength() + x_stockPrice.ele.getComputedTextLength(), price_info_y)
  spread_name.ele.textContent = Gold_Spread_Data.name
  spread_name.attr({ class: "gold-name", "font-weight": "bold" })

  let spread_price = svg.Text((window.innerWidth < 360 ? 88 : 110) + stockPrice.ele.getComputedTextLength() + x_stockName.ele.getComputedTextLength() + x_stockPrice.ele.getComputedTextLength() + spread_name.ele.getComputedTextLength(), price_info_y)
  let spread_price_value = Gold_Spread_Data.klines[Gold_Spread_Data.klines.length - 1].close
  spread_price.ele.textContent = spread_price_value
  spread_price.attr({ class: spread_price_value > 0 ? "gold-price-up" : spread_price_value < 0 ? "gold-price-down" : "gold-price" })

  let stockUnit = svg.Text(width + 7, price_info_y)
  stockUnit.ele.textContent = "（元/克）"
  stockUnit.attr({ class: "gold-price", "text-anchor": "end" })

  if (window.innerWidth < 360) {
    stockName.attr({ "font-size": "12px" })
    stockPrice.attr({ "font-size": "12px" })
    x_stockName.attr({ "font-size": "12px" })
    x_stockPrice.attr({ "font-size": "12px" })
    spread_name.attr({ "font-size": "12px" })
    spread_price.attr({ "font-size": "12px" })
    stockUnit.attr({ "font-size": "12px" })
  }

  // 上线
  let line1 = svg.HLine(0, info_height, options.width)
  line1.attr({ class: "gold-axis" })

  // 中线1
  let line2 = svg.HLine(0, options.height / 4 + info_height / 2, options.width)
  line2.attr({ class: "gold-axis" })

  // 中线2
  let line3 = svg.HLine(0, options.height / 2, options.width)
  line3.attr({ class: "gold-axis" })

  // 中线3
  let line4 = svg.HLine(0, (options.height / 4) * 3 - info_height / 2, options.width)
  line4.attr({ class: "gold-axis" })

  // 下线
  let line5 = svg.HLine(0, options.height - info_height, options.width)
  line5.attr({ class: "gold-axis" })

    //价格2
    let price2 = svg.Text(options.width, height / 4 + fontsize - 2)
    price2.attr({ class: "gold-price", "text-anchor": "end" })
    price2.ele.textContent = gold_middle_price1.toFixed(decimal)
  
    //价格3
    let price3 = svg.Text(options.width, height / 2 - 2)
    price3.attr({ class: "gold-price", "text-anchor": "end" })
    price3.ele.textContent = gold_middle_price2.toFixed(decimal)
  
    //价格4
    let price4 = svg.Text(options.width, (height / 4) * 3 - info_height / 2 - 1)
    price4.attr({ class: "gold-price", "text-anchor": "end" })
    price4.ele.textContent = gold_middle_price3.toFixed(decimal)
  
    //价格1
    let price1 = svg.Text(options.width, info_height + fontsize)
    price1.attr({ class: "gold-price", "text-anchor": "end" })
    price1.ele.textContent = gold_high_price.toFixed(decimal)
  
    //价格5
    let price5 = svg.Text(options.width, options.height - info_height - 2)
    price5.attr({ class: "gold-price", "text-anchor": "end" })
    price5.ele.textContent = gold_low_price.toFixed(decimal)
  
    //价差2
    let spread2 = svg.Text(0, height / 4 + fontsize - 2)
    spread2.attr({ class: "gold-price" })
    spread2.ele.textContent = middle_price1.toFixed(0)
  
    //价差3
    let spread3 = svg.Text(0, height / 2 - 2)
    spread3.attr({ class: "gold-price" })
    spread3.ele.textContent = middle_price2.toFixed(0)
  
    //价差4
    let spread4 = svg.Text(0, (height / 4) * 3 - info_height / 2 - 1)
    spread4.attr({ class: "gold-price" })
    spread4.ele.textContent = (middle_price3 - 1).toFixed(0)
  
    //价差1
    let spread1 = svg.Text(0, info_height + fontsize)
    spread1.attr({ class: "gold-price" })
    spread1.ele.textContent = high_price.toFixed(0)
  
    //价差5
    let spread5 = svg.Text(0, options.height - info_height - 2)
    spread5.attr({ class: "gold-price" })
    spread5.ele.textContent = low_price.toFixed(0)

  let sh_zde_path_d = [] as Array<{ x: number; y: number }>
  SHAU_Data.klines.map(function (v: any, index) {
    if (v.close != null) {
      sh_zde_path_d.push({ x: x_interval / 2 + index * x_interval, y: Math.abs((gold_high_price - v.close) / gold_price_gap) * ih })
    }
  })
  let sh_zde_path = svg.Path(sh_zde_path_d)
  sh_zde_path.attr({
    stroke: "#0065d6",
    fill: "transparent",
    transform: "translate(0," + (info_height + 1) + ")",
  })

  let x_zde_path_d = [] as Array<{ x: number; y: number }>
  XAU_Data.klines.map(function (v: any, index) {
    if (v.close != null) {
      x_zde_path_d.push({ x: x_interval / 2 + index * x_interval, y: Math.abs((gold_high_price - v.close) / gold_price_gap) * ih })
    }
  })
  let x_zde_path = svg.Path(x_zde_path_d)
  x_zde_path.attr({
    stroke: "#e19735",
    fill: "transparent",
    transform: "translate(0," + (info_height + 1) + ")",
  })

  let spread_path_d = [] as Array<{ x: number; y: number }>
  Gold_Spread_Data.klines.map(function (v: any, index) {
    if (v.close != null) {
      let close = Number(v.close).toFixed(0)
      spread_path_d.push({ x: x_interval / 2 + index * x_interval, y: Math.abs((Number(high_price.toFixed(0)) - Number(close)) / Number(spread_gap)) * ih })
    }
  })
  let spread_path = svg.Path(spread_path_d)
  spread_path.attr({
    stroke: "#f7854e",
    "stroke-width": 1.5,
    fill: "transparent",

    transform: "translate(0," + (info_height+8) + ")",
  })


  let start_date = SHAU_Data?.klines?.[0]?.date
  let middle_date = SHAU_Data?.klines?.length > 2 ? SHAU_Data?.klines?.[Math.floor(SHAU_Data.klines.length / 2)]?.date : null
  let end_date = SHAU_Data?.klines?.length > 2 ? SHAU_Data?.klines?.[SHAU_Data.klines.length - 1]?.date : null
  let kline_nums = SHAU_Data.klines.length

  //开始日期
  if (start_date) {
    let date1 = svg.Text(3, options.height - (info_height - fontsize) / 2 - 1)
    date1.ele.textContent = start_date
    date1.attr({ "text-anchor": "start", class: "gold-price" })
  }
  // 中间日期
  if (middle_date) {
    let date2 = svg.Text(((x_interval - rect_width) / 2 + x_interval * kline_nums - 32) / 2 - 10, options.height - (info_height - fontsize) / 2 - 1)
    date2.ele.textContent = middle_date
    date2.attr({ class: "gold-price" })
  }
  //结束日期
  if (end_date) {
    let date3 = svg.Text((x_interval - rect_width) / 2 + x_interval * kline_nums, options.height - (info_height - fontsize) / 2 - 1)
    date3.ele.textContent = end_date
    date3.attr({ "text-anchor": "end", class: "gold-price" })
  }

  //水印
  drawWaterMark(svg.ele, (options.width - 160) / 2, (options.height - 60) / 2)

  //外框
  let outborder = svg.Rect(0, 0, options.width, options.height)
  outborder.attr({ class: "out_border" })
}
